import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import CategoryIcon from "@mui/icons-material/Category";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import api from "../../api/api";
import AddIcon from "@mui/icons-material/Add";

import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  language_change,
  usertype_change,
  topic_change,
  assessment_change,
} from "./StudentAssessment.Slice";
import {
  getCommonQuizTopicThunk,
  getTeacherAssessmentThunk,
  createTeacherAssessmentThunk,
  updateTeacherAssessmentThunk,
  deleteTeacherAssessmentThunk,
} from "./StudentAssessment.Thunk";

import Quiz from "../quiz_template/Quiz";
import { deleteFileFromDB } from "../../components/Azure";

const StudentAssessment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------

  const [anchorEl, setAnchorEl] = useState(null);

  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ---------------- navigate to category page -------------
  const navigate_to = () => {
    dispatch(topic_change(""));
    navigate("/studentassessmentquiz");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const program_select_option_list = [
    { value: "ece", text: "ECE" },
    { value: "pge", text: "PGE" },
  ];

  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];
  const assessment_select_option_list = [
    { value: "baseline", text: "Baseline" },
    { value: "endline", text: "Endline" },
  ];

  const ece_select_option_list = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
  ];

  const pge_select_option_list = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
    { value: "4", text: "4" },
    { value: "5", text: "5" },
  ];

  const questionType_select_option_list = [
    { value: "objective", text: "Objective" },
    { value: "subjective", text: "Subjective" },
  ];

  const ansType_select_option_list = [
    { value: "text", text: "Text" },
    { value: "image", text: "Image" },
    { value: "audio", text: "Audio" },
  ];

  // ---------------------------------------------
  const topicId = useSelector(
    (state) => state.StudentAssessmentSlice.topicId.topicId
  );

  //States-------------------------------------
  const [clas, setClas] = useState("");

  // ------------ dropdowns on change ----------------
  const language_select_onchange = (event) => {
    if (!event.target.value) {
      dispatch(language_change(""));
      dispatch(usertype_change(""));
      dispatch(topic_change(""));
      setProgram("");
      setClas("");
    } else {
      dispatch(language_change(event.target.value));
      dispatch(usertype_change(""));
      dispatch(topic_change(""));
      setProgram("");
      setClas("");
    }
  };

  const usertype_select_onchange = (event) => {
    if (!event.target.value) {
      dispatch(usertype_change(""));
      dispatch(topic_change(""));
      setProgram("");
      setClas("");
    } else {
      dispatch(usertype_change(event.target.value));
      dispatch(topic_change(""));
      setProgram("");
      setClas("");
    }
  };

  const topic_select_onchange = (event, value) => {
    if (!event.target.value) {
      dispatch(topic_change(""));
    } else {
      dispatch(
        topic_change({
          topicId: event.target.value,
          topicName: value.props.children,
        })
      );
      const prm = { usertype, topicId: event.target.value, language };
      dispatch(getTeacherAssessmentThunk(prm));
    }
  };

  //------------------State Handling for the various filters------
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedUsertype, setSelectedUsertype] = useState("");
  const [selectedProgram, setSelectedProgram] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");

  //---------------------------------------------------------------

  useEffect(() => {
    return () => {
      dispatch(topic_change(""));
    };
  }, [dispatch]);

  //*---------Instruction for subjective type-------------
  const [instruction, setInstruction] = useState("");
  const handleChangeInstruction = (e) => {
    setInstruction(e.target.value);
  };

  // !---------Class type selection and handling-----------

  const clas_select_onchange = (event) => {
    if (!event.target.value) {
      dispatch(topic_change(""));
      setClas("");
    } else {
      setClas(event.target.value);
      dispatch(topic_change(""));

      const data = {
        usertype: usertype,
        program: program,
        clas: event.target.value,
      };
      dispatch(getCommonQuizTopicThunk(data));
    }
  };

  const [contents, setContents] = useState([]);

  // -------------------------------------------------

  // ------------ Load data & skill ----------------
  const data = useSelector((state) => state.StudentAssessmentSlice.data);
  //console.log(
  //   "questionCategory------------>",
  //   data[0]?.quizData?.questionCategory
  // );

  const existing_segments =
    data[0]?.quizData?.length > 0 ? data[0]?.quizData : [];
  //console.log("existing_segments-->", existing_segments);

  const topic_select_option_list = useSelector(
    (state) => state.StudentAssessmentSlice.topic
  );

  const language = useSelector(
    (state) => state.StudentAssessmentSlice.language
  );
  let usertype = useSelector((state) => state.StudentAssessmentSlice.usertype);

  const topicName = useSelector(
    (state) => state.StudentAssessmentSlice.topicName
  );

  //  const questionId = useSelector((state) => state.CommonMonthlyQuizSlice.questionId);

  //*--------------Program Selection and handling---------------
  const [program, setProgram] = useState("");
  const program_select_onchange = (e) => {
    if (!e.target.value) {
      setProgram("");
      setClas("");
      dispatch(topic_change(""));
      setSelectedProgram("");
      setSelectedClass("");
      setSelectedTopic("");
    } else {
      setProgram(e.target.value);
      setSelectedClass("");
      setClas("");
      dispatch(topic_change(""));
      setSelectedTopic("");
    }
  };

  // useEffect(() => {
  //   const load_category_list = () => {
  //     const data = {
  //       usertype: usertype,
  //       language: "od",
  //       program: program,
  //       clas: clas, //
  //     };
  //     dispatch(getCommonQuizTopicThunk(data));
  //   };

  //   const load_data = () => {
  //     const params = { usertype, topicId, language };
  //     dispatch(getTeacherAssessmentThunk(params));
  //   };
  //   if (language && usertype) {
  //     load_category_list();
  //     load_data();
  //   }
  // }, [dispatch, usertype, language, topicId, topicName]);

  // -----------------------------------------------

  //todo------------------Subjective Answertype changing------
  const [ansType, setAnsType] = useState("");
  const handleChangeAnsType = (e) => {
    setAnsType(e.target.value);
  };

  //todo------------------Question Type changing-----------------
  const [questionType, setQuestionType] = useState("");
  const [answerType, setAnswerType] = useState("");
  const questionType_select_onchange = (event) => {
    setQuestionType(event.target.value);
    if (event.target.value === "objective") {
      setAnswerType("objective");
    } else if (event.target.value === "subjective") {
      setAnswerType("subjective");
    }
  };

  // For State Declaration
  const [show, setShow] = useState(false);

  //On Modal close and open

  const handleClose = () => setShow(false);
  const handleShow = () => {
    if (language && usertype && topicId && program && clas) {
      setShow(true);
    }
  };

  const [changeA, setChangeA] = useState("");
  const handleChangeA = (event) => {
    setChangeA(event.target.value);
  };
  const [changeB, setChangeB] = useState("");
  const handleChangeB = (event) => {
    setChangeB(event.target.value);
  };
  const [changeC, setChangeC] = useState("");
  const handleChangeC = (event) => {
    setChangeC(event.target.value);
  };
  const [changeD, setChangeD] = useState("");

  const handleChangeD = (event) => {
    setChangeD(event.target.value);
  };
  const [changeAns, setChangeAns] = useState("");

  const handleChangeAns = (event) => {
    setChangeAns(event.target.value); //
  };

  const [changeQuestion, setChangeQuestion] = useState("");
  const handleChangeQuestion = (event) => {
    let qsnValue = event.target.value.toString();
    if (qsnValue.trim === "") {
      toast.error("Minimum 6 letters required");
    } else {
      setChangeQuestion(qsnValue);
    }
  };
  const [questionId, setQuestionId] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const dataa = {
    topicId: topicId,
    // validityStatus,
    quizData: [
      ...existing_segments,
      {
        questionCategory: "objective",
        question: changeQuestion,
        A: changeA,
        B: changeB,
        C: changeC,
        D: changeD,
        correctOption: changeAns,
        program: program,
        class: clas,
        questionId: new Date().getTime(),
      },
    ],
  };

  //! -----------Only for subjective questions----------
  const dataaa = {
    topicId: topicId,
    quizData: [
      ...existing_segments,
      {
        questionCategory: "subjective",
        question: changeQuestion,
        answerType: "text",
        program: program,
        class: clas,
        questionId: new Date().getTime(),
      },
    ],
  };

  const params = { usertype, topicId, language };

  const handleSave = () => {
    let qsnValue = changeQuestion.toString();
    if (qsnValue.trim === "" || qsnValue.length < 6) {
      toast.error("Question should have minimum 6 letters");
    } else if (questionType === "objective" && !changeAns) {
      toast.error("There must be an answer for this question");
    } else if (questionType === "subjective" && ansType) {
      toast.success("Changes made successfully");
      dispatch(createTeacherAssessmentThunk(dataaa)).then((res) => {
        setShow(false);
        setQuestionType("");
        setAnsType("");
        const params = { usertype, topicId, language };
        dispatch(getTeacherAssessmentThunk(params));
      });
    } else {
      setIsLoading(true);
      toast.success("Changes made successfully");
      dispatch(createTeacherAssessmentThunk(dataa))
        .then((res) => {
          setShow(false);
          const params = { usertype, topicId, language };
          dispatch(getTeacherAssessmentThunk(params));
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    }
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const answerTypes = existing_segments.filter(
    (item) => item.answerType === "subjective"
  );

  const getIndividualAnsType = existing_segments.filter(
    (item) => item.question === changeQuestion
  );

  const handleShowUpdate = (eachskill) => {
    setUpdateData({
      A: eachskill.A,
      B: eachskill.B,
      C: eachskill.C,
      D: eachskill.D,
      correctOption: eachskill.correctOption,
      questionId: eachskill.questionId,
      question: eachskill.question,
      questionType: eachskill.questionType,
      answerType: eachskill.answerType,
    });
    setShowUpdate(true);
  };

  const [showUpdate, setShowUpdate] = useState(false);
  const [updateData, setUpdateData] = useState({
    //
    topicId: "",
    quizData: [
      {
        A: "",
        B: "",
        C: "",
        D: "",
        correctOption: "",
        question: "",
        answerType: "objective",
      },
    ],
  });

  const handleUpdateChanges = () => {
    const updateDataSet = existing_segments.map((item) => {
      if (item.questionId === updateData.questionId) {
        return {
          ...item,
          A: updateData.A,
          B: updateData.B,
          C: updateData.C,
          D: updateData.D,
          correctOption: updateData.correctOption,
          question: updateData.question,
        };
      }
      return item;
    });

    const data = {
      topicId: parseInt(topicName.topicId),
      quizData: updateDataSet,
    };
    api
      .put(`updateMasterTtlQuizQuestions`, data)
      .then(
        (response) => {
          toast.success("Changes made successfully");
          const params = { usertype, topicId, language };
          dispatch(getTeacherAssessmentThunk(params));
        },
        (err) => {
          //console.log(err);
          toast.error("Enter a valid Quiz");
        }
      )
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
    setShowUpdate(false);
  };

  //---------------------New  QuizTemplate Logic--------------------------------
  const [showQuizDialog, setShowQuizDialog] = useState(false);
  const [action, setAction] = useState("");
  const [myParams, setMyParams] = useState(null);
  const quiz_on_close = () => setShowQuizDialog(false);

  const quiz_on_save = (quizdata) => {
    if (action === "save") save_quiz_data(quizdata);
    else if (action === "update") update_quiz_data(quizdata);
  };

  const quiz_on_open = (action, quizObject) => {
    if (language && usertype && program && clas) {
      const param = { action, quizObject };
      setAction(action);
      setMyParams(param);
      if (
        language === undefined ||
        language === null ||
        language.trim().length <= 0
      )
        alert("Language is Missing");
      else if (
        usertype === undefined ||
        usertype === null ||
        usertype.trim().length <= 0
      )
        alert("Usertype is Missing");
      else if (
        topicId === undefined ||
        topicId === null ||
        topicId.trim().length <= 0
      )
        alert("Topic is Missing");
      else setShowQuizDialog(true);
    } else {
      toast.error("Please first select all the fields !");
    }
  };

  const save_quiz_data = (quizdata) => {
    setIsLoading(true);
    const newdata = {
      topicId: topicId,
      quizData: [...existing_segments, quizdata],
    };

    setShowQuizDialog(false);
    dispatch(createTeacherAssessmentThunk(newdata))
      .then((res) => {
        const prm = { usertype, topicId, language };
        dispatch(getTeacherAssessmentThunk(prm));
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  const update_quiz_data = (quizdata) => {
    //console.log("quizdata---->", quizdata);
    const updateDataSet = existing_segments.map((item) => {
      if (item.questionId === quizdata.questionId) {
        return {
          ...item,
          ...quizdata,
        };
      }

      return item;
    });

    const data = {
      topicId: topicId,
      quizData: updateDataSet,
    };

    setShowQuizDialog(false);
    //console.log("data--", data);
    api
      .put(`updateMasterTtlQuizQuestions`, data)
      .then(
        (response) => {
          //console.log("response.data---", response.data);
          const params = { usertype, topicId, language };
          dispatch(getTeacherAssessmentThunk(params));
          toast.success("Changes made successfully");
        },
        (err) => {
          //console.log(err);
          toast.error("Enter a valid Quiz");
        }
      )
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  //------------Delete data-------------------------------------
  const delete_quiz_button_click = (item, index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      deleteFileFromDB(item.questionMedia);
      if (result.isConfirmed) {
        const qz = existing_segments.filter((x) => {
          return x.questionId !== item.questionId;
        });
        toast.success("Successfully removed the data");
        //console.log("qz--------->", qz);
        const data = {
          topicId: topicId,
          quizData: qz,
        };
        api
          .put(`updateMasterTtlQuizQuestions`, data)
          .then((response) => {
            toast.success("Changes made successfully");
            const params = { usertype, topicId, language };
            dispatch(getTeacherAssessmentThunk(params));
          })
          .catch((error) => {
            console.error("The error is--------------->", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="Student Assessment" />
        <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={language_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Usertype"
            onChange={usertype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language &&
              usertype_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        {usertype && (
          <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Program</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={program} //
              label="Program"
              onChange={program_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {program_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {program === "ece" ? (
          <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Level</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={clas} //
              label="Level"
              onChange={clas_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype &&
                program &&
                ece_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        ) : program === "pge" ? (
          <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Class</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={clas} //
              label="Class"
              onChange={clas_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype &&
                program &&
                pge_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        ) : null}
        {clas ? (
          <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Topic</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={topicId}
              label="Skill"
              onChange={topic_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {topic_select_option_list.map((option) => (
                <MenuItem key={option.topicId} value={option.topicId}>
                  {option.topicName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : null}
      </div>
      <div>
        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{ m: 1, marginTop: -5, backgroundColor: "blue", height: "38px" }}
          size="small"
        >
          <CategoryIcon
            style={{
              color: "orange",
              marginTop: "-3px",
            }}
          ></CategoryIcon>
          <b style={{ color: "black" }}>Topic</b>
        </Button>
      </div>

      {/* Show List */}
      <div>
        <div>
          {/* {contents.length > 0 ? ( */}
          <Button
            onClick={() => quiz_on_open("save", null)}
            variant="contained"
            sx={{ marginTop: 3, float: "left" }}
          >
            create
            <AddIcon />
          </Button>
          {/* ) : null } */}
          <br />
          <br />
          <br />

          <Quiz
            open={showQuizDialog}
            params={myParams}
            onSubmit={quiz_on_save}
            onClose={quiz_on_close} //
          />
        </div>
        <table style={{ border: "1px solid blue", marginTop: "0px" }}>
          {language &&
            usertype &&
            program &&
            clas &&
            existing_segments.map(
              (
                eachskill,
                index //\
              ) => (
                <thead>
                  <tr>
                    <th
                      style={{
                        width: "700px",
                        textAlign: "left",
                        wordBreak: "break-all",
                      }}
                    >
                      {" "}
                      {index + 1}.{eachskill.question}
                    </th>
                  </tr>
                  <tbody>
                    {/* <tr>
                      {eachskill.instructions ? (
                        <td style={{ width: "350px", wordBreak: "break-all" }}>
                          {eachskill.instructions && (
                            <div> Instruction:{eachskill.instructions}</div>
                          )}
                        </td>
                      ) : null}
                    </tr> */}

                    <tr>
                      <td style={{ width: "350px", wordBreak: "break-all" }}>
                        {/* {questionType === "subjective" && instruction && (
                        <p>Instruction : {instruction}</p>
                      )} */}
                        {eachskill.optionA && <div> A.{eachskill.optionA}</div>}
                      </td>
                      {eachskill.optionB && (
                        <td style={{ width: "350px", wordBreak: "break-all" }}>
                          B.{eachskill.optionB}
                        </td>
                      )}
                      <td>
                        <Button
                          variant="contained"
                          onClick={() => quiz_on_open("update", eachskill)} //
                        >
                          Update
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="contained"
                          onClick={() => delete_quiz_button_click(eachskill)} //
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      {eachskill.optionC && (
                        <td style={{ width: "350px", wordBreak: "break-all" }}>
                          C.{eachskill.optionC}
                        </td>
                      )}
                      {eachskill.optionD && (
                        <td style={{ width: "350px", wordBreak: "break-all" }}>
                          D.{eachskill.optionD}
                        </td>
                      )}
                    </tr>
                    {eachskill.correctOption &&
                    eachskill.correctOption.length > 0 ? (
                      <tr>
                        <td>
                          <b>Answer-</b>
                          {eachskill.correctOption}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </thead>
              )
            )}
        </table>
      </div>
      <ToastContainer />
    </>
  );
};

export default StudentAssessment;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
